import { colors } from 'crono-fe-common/theme';
import styled from '@emotion/styled';

export const GuidedTourSpotlightWrapper = styled.div`
  position: relative;
  z-index: 10000;
  background: ${colors.white};
  border-radius: 20px;
  overflow: hidden;
`;

export const GuidedTourSpotlightTextWrapper = styled.div`
  padding: 12px 14px;
  border-radius: 8px;
  max-width: 262px;
  display: flex;
  background: ${colors.white};
  position: absolute;
  z-index: 10001;
  .close-icon {
    cursor: pointer;
    flex-shrink: 0;
  }
  .guided-tour-spotlight-arrow {
    position: absolute;
    width: 8px;
    height: 8px;
    background-color: ${colors.white};
    border-radius: 1px;
    z-index: -1;
    transform: rotate(45deg);
    border-left: none;
    border-top: none;
  }
`;
